<script>
import { Pie, mixins } from 'vue-chartjs';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
const { reactiveProp } = mixins;

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    pieData: {
      labels: [],
      datasets: [
        {
          backgroundColor: [
            '#41B883', 
            '#E46651', 
            '#00D8FF', 
            '#DD1B16'
          ],
          data: []
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'right'
      },
      plugins: {
        datalabels: {
          formatter: (value, dnct1) => {
            let sum = 0;
            let dataArr = dnct1.chart.data.datasets[0].data;
            dataArr.map(data => {
              sum += Number(data);
            });

            let percentage = `${(value * 100 / sum).toFixed(2)}%`;
            return percentage;
          },
          color: '#ff3',
        }
      },
    }
  }),
  mounted() {
    this.getData();
    this.addPlugin(ChartJsPluginDataLabels);
  },
  methods: {
    getData(){
      const app = this;
      axios.get("api/v1/get-count-support-by-status")
        .then(response => {
          app.pieData.labels = [];
          app.pieData.datasets[0].data = [];
          response.data.forEach(function(el){
            app.pieData.labels.push(el.status == 1 ? 'Đã phản hồi' : 'Chưa');
            app.pieData.datasets[0].data.push(el.amount);
          })
          app.renderChart(app.pieData, app.options);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
</script>